import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import './ArticleHeroA.scss';
import SocialShare from '../ArticleSocialShare/ArticleSocialShare';
import HeroNmpVideo, {
  heroNmpAutoplayOn,
  heroUsesNmpVideo,
} from '../HeroNmpVideo/HeroNmpVideo';

export default class ArticleHeroA extends Component {
  constructor(props) {
    super(props);
    const nmpAutoplay =
      heroUsesNmpVideo(props.heroVideoSource, props.nmpAssetId) &&
      heroNmpAutoplayOn(props.nmpAutoplay);
    this.state = { playing: nmpAutoplay };
  }

  render() {
    let {
      postDate,
      textColor,
      highlightColor,
      heroImage,
      title,
      youtubeId,
      heroImageWidth,
      heroVideoSource,
      nmpAssetId,
      nmpAutoplay,
      nmpHideControls,
      nmpMuted,
      nmpLoop,
      nmpTheme,
    } = this.props;

    const useNmp = heroUsesNmpVideo(heroVideoSource, nmpAssetId);
    const nmpAutoplayOn = useNmp && heroNmpAutoplayOn(nmpAutoplay);
    const hasYoutube = !useNmp && youtubeId;
    const hasVideo = useNmp || hasYoutube;
    const isVideoWidth = heroImageWidth === 'video';
    const nmpFit = 'contain';
    const isPlaying =
      nmpAutoplayOn || (this.state.playing && hasYoutube);

    const headlineStyle = {};
    if (textColor && textColor.startsWith('#')) {
      headlineStyle.color = textColor;
    }
    if (highlightColor && highlightColor.startsWith('#')) {
      headlineStyle.backgroundImage = `linear-gradient(90deg, ${highlightColor} 0, ${highlightColor} 0)`;
    }

    return (
      <div
        className={`article-hero-A ctnr ${
          isVideoWidth ? 'article-hero-A--width-video' : ''
        } ${useNmp ? 'article-hero-A--has-nmp' : ''}`}
      >
        {hasYoutube && !nmpAutoplayOn && (
          <div
            className={`article-hero-A__click-target ${
              isPlaying ? 'playing' : ''
            }`}
            onClick={() => {
              this.setState({ playing: true });
            }}
          />
        )}
        {heroImage.asset && (
          <React.Fragment>
            <div
              className={`article-hero-A__img-ctnr ${
                isPlaying && hasVideo ? 'playing' : ''
              }`}
            >
              <div
                className={`article-hero-A__img ${hasVideo ? 'has-video' : ''}`}
                style={{
                  backgroundImage: `url(${heroImage.background.dataOriginal})`,
                  backgroundPosition: `${heroImage.focus.x * 100}% ${heroImage.focus.y * 100}%`,
                }}
                alt=""
                dangerouslySetInnerHTML={{ __html: heroImage.asset }}
              />
              {useNmp && (
                <HeroNmpVideo
                  className="article-hero-A__nmp-video"
                  fit={nmpFit}
                  nmpAssetId={nmpAssetId}
                  nmpAutoplay={nmpAutoplay}
                  nmpHideControls={nmpHideControls}
                  nmpMuted={nmpMuted}
                  nmpLoop={nmpLoop}
                  nmpTheme={nmpTheme}
                />
              )}
              {hasYoutube && (
                <React.Fragment>
                  <ReactPlayer
                    width={'100%'}
                    height={'100%'}
                    url={`${youtubeId}`}
                    playing={this.state.playing}
                    playsinline={false}
                    className={'article-hero-A__video react-player'}
                    tabIndex={1}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        this.setState({ playing: true });
                      }
                    }}
                    config={{
                      youtube: {
                        playerVars: { rel: 0, controls: 1, playsinline: 0 },
                        embedOptions: {
                          host: 'https://www.youtube-nocookie.com',
                        },
                      },
                    }}
                  />
                  {!nmpAutoplayOn && (
                    <img
                      src="/icons/misc/VideoPlay.svg"
                      className="article-hero-A__play-btn play-btn"
                      alt="Play video"
                    />
                  )}
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
        <div className="article-hero-A__content">
          <div className={`article-hero-A__headline`}>
            <h1
              className={` headline--xl headline--highlight headline--highlight-${highlightColor} ${textColor}`}
              style={headlineStyle}
            >
              {title}
            </h1>
          </div>

          {postDate && <p className="article-hero-A__date date">{postDate}</p>}

          <SocialShare />
        </div>
      </div>
    );
  }
}
